module.exports = __webpack_public_path__ + "static/media/world.89a63b58.png";